import { faEye as faLightEye, faThumbTack as faLightThumbTack } from '@fortawesome/pro-light-svg-icons';
import { faEye as faSolidEye, faThumbTack as faSolidThumbTack } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Banner, IconButton, List } from '@nexelem/components';
import { createDrawer, Drawer } from '@nexelem/drawer';
import { cn } from '@nexelem/utils';
import { useTableTranslation } from '../translations';
import { useTable } from '../utils';
import { getColumnListItems, reorderColumns } from './reorderColumns';

const ColumnsOrderDrawer = () => {
  const { t } = useTableTranslation();
  const table = useTable();
  const columns = getColumnListItems(table);

  return (
    <Drawer>
      <Drawer.Header
        title={<div className="text-t24-sb">{t('columnsOrderSettings')}</div>}
        onClose={closeColumnsOrderDrawer}
      />

      <Drawer.Content>
        <div className="mb-6 flex flex-col gap-4">
          <div className="text-s16">{t('columnsOrderInfo')}</div>
          <Banner message={t('columnsOrderInfoBanner')} type="info" />
        </div>
        <List.DragDropProvider onDragEnd={(event) => reorderColumns(table, event)}>
          <List.Root>
            {columns.map(({ column, index, group }) => {
              const isVisible = column.getIsVisible();
              const isPinned = column.getIsPinned();

              const handlePin = () => {
                isPinned ? column.pin(false) : column.pin('left');
              };

              return (
                <List.Item
                  sortable
                  group={group}
                  hiddenState={!isVisible}
                  id={column.id}
                  index={index}
                  key={column.id}
                  Actions={
                    <span className="text-nowrap">
                      <IconButton
                        className={cn(!isVisible ? 'text-text-secondary-darker' : 'text-text-focus')}
                        Icon={<FontAwesomeIcon icon={isPinned ? faSolidThumbTack : faLightThumbTack} />}
                        onClick={handlePin}
                      />
                      <IconButton
                        className={cn(!isVisible ? 'text-text-secondary-darker' : 'text-text-focus')}
                        Icon={<FontAwesomeIcon icon={isVisible ? faSolidEye : faLightEye} />}
                        onClick={() => column.toggleVisibility(!isVisible)}
                      />
                    </span>
                  }
                >
                  {typeof column.columnDef.header === 'string' ? column.columnDef.header : column.id}
                </List.Item>
              );
            })}
          </List.Root>
        </List.DragDropProvider>
      </Drawer.Content>
      <Drawer.Footer></Drawer.Footer>
    </Drawer>
  );
};

export const { toggleColumnsOrderDrawer, closeColumnsOrderDrawer } = createDrawer(ColumnsOrderDrawer, {
  name: 'ColumnsOrderDrawer',
  slot: 'right',
  width: 420,
  drawerId: () => 'columns-order-drawer',
});
